import * as React from 'react';
import Modal from 'react-modal';
import {
    BootstrapTable,
    TableHeaderColumn,
    ButtonGroup
} from 'react-bootstrap-table';
import { Button, Alert } from 'react-bootstrap'
import { isEmpty, isUndefined, findIndex, filter } from 'lodash';

import { clearNonNumberCharacters, Component, getRandomKey, I18NString } from "../../Utils";
import { IControlError, IControlSchema } from "../../Controls";
import { ApiClient } from "../../../services/ApiClient";
import { IDispatcher } from "../extensions/Dispatcher";

import Field from '../Field';

import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import { clearSpaces, getFormatterNumber, isStringANumber } from "../../../helpers/getFormatterNumber";

interface TableColum {
    disabled: boolean;
    field: string;
    name: string;
    description: I18NString;
    format?: any;
    editable?: any;
    hiddenOnInsert?: any;
    required: boolean;
    isKey: boolean;
    type?: any
}

interface GridSchema extends IControlSchema {
    columns: Array<TableColum>,
    value?: Array<any>,
    disabled?: boolean,
    maxRowCount?: number;
    description?: I18NString;
    extra: {
        del_row_enabled: boolean;
        add_row_enabled: boolean;
        hint: string;
    }
}

interface IGridProps {
    schema: GridSchema;
    api: ApiClient;
    dispatcher?: IDispatcher;
    error: IControlError | undefined;
    visited: boolean;
}

interface IGridState {
    selectRow: object,
    values: Array<any>,
    showHelp: boolean;
}

interface ModalEditorState {
    open: boolean;
}

interface ModalEditorProps {
    title: string;
    columns: Array<TableColum>;
    cells: Object;
    onSave: (row: object) => void;
}

interface EditorModalTableProps {
    columns: Array<TableColum>;
    onSave: (row: object) => void;
    onModalClose: () => void;
    title: string;
    schema?: any;
    value?: Object;
    disabled?: boolean;
    defaulValue?: any;
    rowCount?: any;
}

interface EditorModalTableState {
    validateState: { [key: string]: string }
}

class Description extends React.Component<{ text: I18NString }, { isOpen: boolean }>{
    state = {
        isOpen: false
    }

    onClick = () => {
        this.setState(({ isOpen }) => ({ isOpen: !isOpen }))
    }

    render() {
        return (
          <div>
              <div className="input-group">
                  {this.props.children}
                  {(this.props.text) && (
                    <span onClick={this.onClick} role="button" className="input-group-addon btn btn-default">
                            <span className="fa fa-question-circle-o fa-fw" />
                        </span>
                  )}
              </div>
              {(this.props.text && this.state.isOpen) && (
                <div  className="alert alert-warning" role="alert">
                    {this.props.text.ru}
                </div>
              )}
          </div>
        )
    }
}

class EditorModalTable extends React.Component<EditorModalTableProps, EditorModalTableState>{
    public refs: { [key: string]: HTMLInputElement }

    state = {
        validateState: {}
    }

    getFieldValue = () => {
        const newRow = {};

        this.props.columns.forEach((column: TableColum) => {
            const value = this.refs[column.field]
              && (this.refs[column.field].dataset.value
                  ? this.refs[column.field].dataset.value : this.refs[column.field].value
              );
            newRow[column.field] = !column.isKey ? value : `key_${getRandomKey()}`;
        }, this);

        return newRow;
    }

    onClick = () => {
        let rows = this.getFieldValue();
        let validateState = {}

        this.props.columns.forEach((column: TableColum) => {
            if (!column.isKey) {
                let value = this.refs[column.field].value;
                if (column.required && value === "") {
                    validateState[column.field] = 'Обязательное поле для заполнения'
                }
            } else {

                if (!isUndefined(this.props.value)) {
                    rows[column.field] = this.props.value[column.field]
                }
            }

            if (column.type && column.type.type === "Number" && isStringANumber(rows[column.field])) {
                validateState[column.field] = 'Неверное значение'
            }

            if (!validateState[column.field] && column.type && column.type.type === "Number") {
                rows[column.field] = clearSpaces(this.refs[column.field].value, true);
            }

        }, this);

        this.setState({ validateState });
        if (isEmpty(validateState)) {
            this.props.onSave(rows);
            this.props.onModalClose();
        }
    }

    checkIfFormat = (fieldId: string, isInteger?: boolean) => {
        return (event: React.KeyboardEvent<HTMLInputElement>): void => {
            this.refs[fieldId].value = clearNonNumberCharacters(this.refs[fieldId].value, isInteger);
        }
    }

    stopDefaultEvents = (event) => {
        event.preventDefault();
        event.stopPropagation();
    }

    onBlurNumber = (fieldId: string) => () => {
        this.refs[fieldId].value = getFormatterNumber(this.refs[fieldId].value, true)
    }

    onFocusNumber = (fieldId: string) => () => {
        this.refs[fieldId].value = clearSpaces(this.refs[fieldId].value, true);
    }

    createControl = (column: TableColum) => {
        let { value, rowCount } = this.props;

        let defaultValue = this.props.schema
        && this.props.schema.defaultValue
        && this.props.schema.defaultValue[rowCount]
        && this.props.schema.defaultValue[rowCount][column.field]
          ? this.props.schema.defaultValue[rowCount][column.field] : '';

        if (column.name == "№") {
            return (
              <Description text={column.description}>
                  <span
                    ref={column.field}
                    data-value={(value && value[column.field] ? value[column.field] : this.props.rowCount + 1).toString()}
                  >
                    {(value && value[column.field] ? value[column.field] : this.props.rowCount + 1).toString()}
                  </span>
              </Description>
            )
        }

        if (column.type !== null) {
            switch (column.type.type.toUpperCase()) {
                case "SELECT": return (
                  <Description text={column.description}>
                      <select ref={column.field} className="form-control" disabled={column.disabled}>
                          {
                              column.type.options.values.map((str, idx) => {
                                  return !isUndefined(this.props.value) &&
                                  value[column.field] === str ?
                                    (<option key={idx} value={str} selected={true} >{str}</option>) :
                                    (<option key={idx} value={str}>{str}</option>)
                              })
                          }
                      </select>
                  </Description>
                );
                case "NUMBER": return (
                  <>
                      <Description text={column.description}>
                          <input
                            type="text"
                            inputMode="decimal"
                            className="form-control editor edit-text"
                            onBlur={this.onBlurNumber(column.field)}
                            onFocus={this.onFocusNumber(column.field)}
                            onInput={this.checkIfFormat(column.field, !!column.type.isInteger)}
                            onPaste={this.stopDefaultEvents}
                            ref={column.field}
                            disabled={column.disabled}
                            defaultValue={
                              isUndefined(this.props.value)
                                ? getFormatterNumber(defaultValue, true)
                                : getFormatterNumber(this.props.value[column.field], true)
                            }
                          />
                      </Description>
                  </>
                );
            }
        } else {
            return (
              <Description text={column.description}>
                  <input type="text"
                         className="form-control editor edit-text"
                         ref={column.field}
                         disabled={column.disabled}
                         defaultValue={isUndefined(this.props.value) ? '' : this.props.value[column.field]}
                  />
              </Description>
            )
        }
    }

    render() {
        const { title, columns, onModalClose } = this.props;
        const { validateState } = this.state;

        return (
          <div className="modal-content react-bs-table-insert-modal">
              <div className="modal-header ">
                  <button type="button" className="close" onClick={onModalClose} >
                      <span aria-hidden="true">×</span>
                  </button>
                  <h4 className="modal-title">{title}</h4>
              </div>
              <div className="modal-body">
                  {columns.map((column: TableColum, idx: number) => {
                      const {
                          required,
                          field,
                          name,
                          isKey,
                      } = column;

                      return !isKey && (
                        <div className="form-group" key={field}>
                            <label className={required ? 'required' : ''}>
                                {name}
                            </label>
                            {this.createControl(column)}
                            {validateState[field] && (
                              <span className='label label-danger'>
                                      {validateState[field]}
                                  </span>
                            )}
                        </div>
                      );
                  })}
              </div>
              <div className="modal-footer">
                  <button type="button" className="btn btn-default btn-secondary" onClick={onModalClose}>Отмена</button>
                  <button type="button" className="btn btn-primary" onClick={this.onClick}>Сохранить</button>
              </div>
          </div>
        )
    }
}

class ModalEditor extends React.Component<ModalEditorProps, ModalEditorState> {
    state = {
        open: false
    }

    onClose = () => {
        this.setState({ open: false });
    }

    onShow = () => {
        this.setState({ open: true })
    }

    render() {
        const { columns, cells, onSave } = this.props;
        const { open } = this.state;

        return (
          <Modal
            isOpen={open}
            className='react-bs-insert-modal modal-dialog'
            contentLabel='Modal'
            ariaHideApp={false}
          >
              <EditorModalTable
                title="Редактировать"
                value={cells}
                onModalClose={this.onClose}
                columns={columns}
                onSave={onSave}
              />
          </Modal>
        )
    }
}

class Grid extends Component<IGridProps, IGridState> {
    private modal: ModalEditor;

    state = {
        selectRow: {},
        values: [],
        showHelp: false
    }

    componentDidMount() {
        const { schema: {value} } = this.props;

        if (!isUndefined(value)) {
            this.setState({
                values: value
            });
        }
    }

    onClick = () => {
        if (!isEmpty(this.state.selectRow)) {
            this.modal.onShow();
        }
    }

    getFieldKey = () => {
        const { columns } = this.props.schema;
        let idx = findIndex(columns, (col: TableColum) => col.isKey);

        return columns[idx].field;
    }

    onSave = (row: Object) => {
        const { dispatcher, schema } = this.props,
          fieldKey = this.getFieldKey(),
          values = [...this.state.values],
          index = findIndex(values, (val: Object) => val[fieldKey] === row[fieldKey]);

        if (index > -1) {
            values[index] = row;
        }
        else {
            values.push(row);
        }

        this.setState({ values: [...values] });
        if (this.state.selectRow && this.state.selectRow[fieldKey] === row[fieldKey]) {
            this.setState({selectRow: row});
        }
        dispatcher.onBlur(schema.id, values, true, undefined);
    }

    onDelete = () => {
        const { schema, dispatcher, } = this.props;
        // TODO: values???
        const values = [...this.state.values];

        if (!isEmpty(this.state.selectRow)) {
            let fieldKey = this.getFieldKey(),
              values = filter(schema.value,
                (o: Object) => o[fieldKey] !== this.state.selectRow[fieldKey]);

            dispatcher.onBlur(schema.id, values, true, undefined);
            this.setState({ values: [...values], selectRow: {} });
        }
    }


    onDbClick = (row) => {
        this.setState({ selectRow: row });
        this.modal.onShow();
    }

    helpClick = () =>  {
        this.setState(({ showHelp }) => ({ showHelp: !showHelp }))
    }

    render() {
        const { schema: { extra, disabled, maxRowCount, visible}, error } = this.props;
        const length = this.state.values.length;
        const errorMessage = error && error.message;

        const config = {
            insertRow: !disabled && (maxRowCount ? length < maxRowCount : true)
              && (!isUndefined(extra) && !isUndefined(extra.add_row_enabled) ? extra.add_row_enabled : true),
            deleteRow: !disabled && (!isUndefined(extra) && !isUndefined(extra.del_row_enabled) ? extra.add_row_enabled : true),
            height: '210px',

            selectRow: {
                mode: 'radio',
                bgColor: '#ddd',
                hideSelectColumn: true,
                clickToSelect: true,
                onSelect: (row, isSelected: boolean, e) => this.setState({ selectRow: (isSelected ? row : {}) })
            },
            options: {
                insertText: 'Добавить',
                noDataText: 'Нет данных для отображения',
                onRowDoubleClick: !disabled ? this.onDbClick : {},

                deleteBtn: (onClick: any) => {
                    if(!isUndefined(extra) && !isUndefined(extra.del_row_enabled) ? extra.del_row_enabled : true) {
                        return <Button onClick={this.onDelete} bsStyle="danger">
                            <span className='fa fa-trash'></span>
                            Удалить
                        </Button>
                    }
                },

                btnGroup: props => (
                  <ButtonGroup>
                      {props.insertBtn}
                      {(!disabled) && (
                        <Button bsStyle="success" onClick={this.onClick}>
                            <span className='fa fa-edit'></span>
                            Редактировать
                        </Button>
                      )}
                      {props.deleteBtn}
                      {!isUndefined(this.props.schema.description) && (
                        <Button onClick={this.helpClick} bsStyle="primary" title="Справка">
                            <span className="fa fa-question-circle-o fa-fw" />
                        </Button>
                      )}
                  </ButtonGroup>
                ),

                insertModal: (onModalClose) => (
                  <EditorModalTable
                    title="Добавить"
                    onModalClose={onModalClose}
                    columns={this.props.schema.columns}
                    onSave={this.onSave}
                    disabled={disabled}
                    schema={this.props.schema}
                    rowCount={length}
                  />
                )

            }
        }
        let customCell = (cell, row) => <span title={cell}>{cell}</span>
        return isUndefined(visible) || visible ? (
          <Field {...this.props.schema} status={isEmpty(this.state.values) ? "default" : "success"} >
              {this.props.schema.extra && this.props.schema.extra.hint && (
                <div
                  className="alert alert-info hint"
                  dangerouslySetInnerHTML={{__html: this.props.schema.extra.hint}}
                />
              )}
              <BootstrapTable {...config} data={this.state.values} bodyContainerClass="react-bs-container-body_v1">
                  {this.props.schema.columns.map((column: TableColum, idx: number) => (
                    <TableHeaderColumn
                      isKey={column.isKey}
                      hidden={column.isKey}
                      thStyle={{ whiteSpace: "normal" }}
                      dataFormat={customCell}
                      key={idx} dataField={column.field}
                    >
                        {column.name}
                    </TableHeaderColumn>
                  ))}
              </BootstrapTable>
              <ModalEditor
                ref={(modal) => this.modal = modal}
                title="Редактировать"
                columns={this.props.schema.columns}
                onSave={this.onSave}
                cells={this.state.selectRow}
              />
              {errorMessage && (
                <Alert bsStyle="danger">{errorMessage}</Alert>
              )}
              {this.state.showHelp && (
                <Alert bsStyle="warning">
                    <div dangerouslySetInnerHTML={{ __html: this.props.schema.description.ru }}></div>
                </Alert>
              )}
          </Field>
        ) : <div />
    }
}

export function createGrid(
  schema: IControlSchema,
  api: ApiClient,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean
): React.ReactElement<any> {
    return (
      <Grid
        schema={schema as GridSchema}
        api={api}
        error={error}
        visited={visited}
        dispatcher={dispatcher}
      />
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/standart/Grid.tsx